// extracted by mini-css-extract-plugin
module.exports = {"Checkbox__root":"Checkbox_Checkbox__root__2xGc9","checked":"Checkbox_checked__3CYn4","disabled":"Checkbox_disabled__3TuYg","Label":"Checkbox_Label__2F8tL"};